import { Tooltip } from '@routable/gross-ds';
import React from 'react';
import DashboardToDashboardRestrictionTooltipContent from 'components/dashboardToDashboardRestrictionTooltipContent';
const tooltipContent = (React.createElement("div", { className: "p-3 max-w-[320px]" },
    React.createElement(DashboardToDashboardRestrictionTooltipContent, null)));
export const PartnerSelfManagedTooltip = ({ children }) => (React.createElement(Tooltip, { "data-testid": "partner-self-managed-tooltip", tooltip: tooltipContent, variant: "light" },
    React.createElement("span", { className: "font-color--main-blue cursor-pointer" }, children)));
